import React from 'react';
import PropTypes from 'prop-types';

import InputWrapper from '../InputWrapper';
import ValidationMessage from '../ValidationMessage';

const SimpleSelect = ({
  children,
  isDisabled,
  id,
  isRequired,
  isSelectGroup,
  label,
  name,
  onBlur,
  onChange,
  options,
  placeholder,
  isPlaceholderDisabled,
  validationMessage,
  validationState,
  value,

  inputLabelProps,
  inputWrapperProps,
  placeholderOptionProps,
  selectProps,
  validationMessageProps
}) => (
  <InputWrapper
    className='input--select'
    disableInputStyle={!isSelectGroup}
    disableValidationStyle={!isSelectGroup}
    validationState={validationState}
    label={label}
    inputLabelProps={inputLabelProps}
    isRequired={isRequired}
    id={id}
    name={name}
    {...inputWrapperProps}
  >
    <select
      className='input__select'
      id={id || name}
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      required={isRequired}
      disabled={isDisabled}
      {...selectProps}
    >
      {placeholder && (
        <option
          value=''
          disabled={isPlaceholderDisabled}
          {...placeholderOptionProps}
        >
          {placeholder}
        </option>
      )}
      {children ||
        (options &&
          options.map(
            ({ value: optionValue, text: optionText, ...otherOptionProps }) => (
              <option
                value={optionValue}
                key={optionText}
                {...otherOptionProps}
              >
                {optionText}
              </option>
            )
          ))}
    </select>
    <ValidationMessage
      validationState={validationState}
      {...validationMessageProps}
    >
      {validationMessage}
    </ValidationMessage>
  </InputWrapper>
);

SimpleSelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isSelectGroup: true,
  value: '',
  isPlaceholderDisabled: true
};

SimpleSelect.propTypes = {
  /* Required */
  name: PropTypes.string.isRequired,
  /* Regular */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isSelectGroup: PropTypes.bool,
  isPlaceholderDisabled: PropTypes.bool,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    /* Fragment case */
    PropTypes.object
  ]),
  placeholder: PropTypes.string,
  validationMessage: PropTypes.string,
  validationState: PropTypes.oneOf(['success', 'warning', 'error', undefined]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.number
  ]),
  /* Components Props */
  inputLabelProps: PropTypes.object,
  inputWrapperProps: PropTypes.object,
  placeholderOptionProps: PropTypes.object,
  selectProps: PropTypes.object,
  validationMessageProps: PropTypes.object
};

export default SimpleSelect;
